import { LoadableAfterPaint, LoadableLazy } from '@confluence/loadable';

export const DevToolsDialog = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-DevToolsDialog" */ './DevToolsDialog.tsx'))
			.DevToolsDialog,
});

export const LazyDevToolsDialog = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-DevToolsDialog" */ './DevToolsDialog.tsx'))
			.DevToolsDialog,
});

export const DevToolsBanner = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-DevToolsBanner" */ './DevToolsBanner.tsx'))
			.DevToolsBanner,
});
